






























import { Mixins } from 'vue-mixin-decorator'
import { Component, Emit, Prop } from 'vue-property-decorator'

import SpaErrorDialog from '@/components/organisms/dialog/ErrorDialog.vue'
import OrderList from '@spa/components/organisms/mypage/order/OrderList.vue'
import LoadingMixin, { Status } from '@spa/mixins/loading'
import { PluginMixin } from '@spa/mixins/plugin'
import { getPage } from '@spa/store/modules/orderHistory/functions/page'
import { Order, Page } from '@spa/store/modules/orderHistory/types'
import HistoryPagination from './HistoryPagination.vue'

@Component({
  components: {
    HistoryPagination,
    OrderList,
    SpaErrorDialog,
  },
  mixins: [
    LoadingMixin,
  ],
})
export default class HistoryPage extends Mixins<PluginMixin>(PluginMixin) {
  Status = Status
  @Prop({ required: true })
  status: Status

  showModal: boolean = false
  modalMessage: string = ''

  @Prop({ required: true })
  pageNumber: number

  get isLoading(): boolean {
    return this.status === Status.Loading
  }

  get page(): Page | null {
    return getPage(this.$store.state.orderHistory.pages, this.pageNumber) || null
  }

  get orders(): Order[] {
    if (!this.page) {
      return []
    }

    return this.page.items
  }

  get error(): Error | null {
    if (!this.page) {
      return new Error(`No page is found with page number = ${this.pageNumber}`)
    }

    return this.page.error || null
  }

  get hasEmptyOrders(): boolean {
    return this.orders.length === 0
  }

  onNewPageSelect(pageNumber: number) {
    this.newPageSelected(pageNumber)
  }

  @Emit()
  newPageSelected(_pageNumber: number) {
    // Do nothing
  }
}
